<template>
    <div :class="[
        'form__modulesform',
        dragModeActive ? 'form__modulesform--dragmode' : ''
    ]">
        <form-modulesform-item
            v-for="(module, moduleIndex) in modules"
            :key="`course-edit-modules-${moduleIndex}-${rerenderIndex}`"
            :index="[...index, moduleIndex]"
            :module="module"
            :drag-mode-active="dragModeActive"
            :drag-item="{ index: dragItemIndex, type: dragItemType }"
            :is-any-editable="isAnyFieldEditable"
            :disabled="disabled"
            @emit-add="emitAdd"
            @emit-remove="emitRemove"
            @emit-move="emitMove"
        ></form-modulesform-item>
        <template v-if="index.length === 0">
            <div class="form__modulesform_addactions">
                <div class="columns">
                    <div class="column">
                        <component-button
                            :disabled="!allowEdit || isShowMode || isAnyFieldEditable || disabled"
                            :name="'form-moduleform-add-note'"
                            :icon="true"
                            :icon-name="'file-plus'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitAdd({ type: 'note' })"
                        >Add note
                        </component-button>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <component-button
                            :disabled="!allowEdit || isShowMode || isAnyFieldEditable || disabled"
                            :name="'form-moduleform-add-module'"
                            :icon="true"
                            :icon-name="'plus-circle'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitAdd({ type: 'module', subType: 'event' })"
                        >Add event
                        </component-button>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <component-button
                            :disabled="!allowEdit || isShowMode || isAnyFieldEditable || disabled"
                            :name="'form-moduleform-add-module'"
                            :icon="true"
                            :icon-name="'plus-square'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitAdd({ type: 'module', subType: 'scorm' })"
                        >Add SCORM module
                        </component-button>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <component-button
                            :disabled="!allowEdit || isShowMode || isAnyFieldEditable || disabled"
                            :name="'form-moduleform-add-group'"
                            :icon="true"
                            :icon-name="'folder-plus'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="emitAdd({ type: 'group' })"
                        >Add section
                        </component-button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import FormModulesformItem from '@/components/default/forms/FormModulesformItem'
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'form-modulesform',
  components: { ComponentButton, FormModulesformItem },
  data () {
    return {
      dragModeActive: false,
      dragItemIndex: '',
      dragItemType: '',
      rerenderIndex: 0,
      isAnyNameEditable: false,
      isAnyExternalIdEditable: false,
      isAnyDescriptionEditable: false
    }
  },
  props: {
    modules: {
      type: Array,
      required: true
    },
    index: {
      type: [Array, Number],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allowEdit () {
      return this.$store.getters.getEbsCourseAllowEdit
    },
    //
    isAddMode () {
      return this.$route.name.includes('course-add')
    },
    isEditMode () {
      return this.$route.name.includes('course-edit')
    },
    isShowMode () {
      return this.$route.name.includes('course-show')
    },
    isAnyFieldEditable () {
      return this.isAnyNameEditable || this.isAnyExternalIdEditable || this.isAnyDescriptionEditable
    }
  },
  methods: {
    emitAdd (data) {
      this.rerenderIndex++
      this.$emit('emit-add', data)
    },
    emitRemove (data) {
      this.rerenderIndex++
      this.$emit('emit-remove', data)
    },
    emitMove (data) {
      this.rerenderIndex++
      this.$emit('emit-move', data)
    },
    enableDragMode (data) {
      this.dragItemIndex = data.index
      this.dragItemType = data.type
      this.dragModeActive = true
    },
    disableDragMode () {
      this.dragItemIndex = ''
      this.dragItemType = ''
      this.dragModeActive = false
    },
    enableNameEditable () {
      this.isAnyNameEditable = true
    },
    disableNameEditable () {
      this.isAnyNameEditable = false
    },
    enableExternalIdEditable () {
      this.isAnyExternalIdEditable = true
    },
    disableExternalIdEditable () {
      this.isAnyExternalIdEditable = false
    },
    enableDescriptionEditable () {
      this.isAnyDescriptionEditable = true
    },
    disableDescriptionEditable () {
      this.isAnyDescriptionEditable = false
    }
  },
  mounted () {
    this.$eventBus.$on(`form-modules-dragstart`, this.enableDragMode)
    this.$eventBus.$on(`form-modules-dragend`, this.disableDragMode)
    this.$eventBus.$on(`form-modules-enable-name-editable`, this.enableNameEditable)
    this.$eventBus.$on(`form-modules-enable-externalid-editable`, this.enableExternalIdEditable)
    this.$eventBus.$on(`form-modules-enable-description-editable`, this.enableDescriptionEditable)
    this.$eventBus.$on(`form-modules-disable-name-editable`, this.disableNameEditable)
    this.$eventBus.$on(`form-modules-disable-externalid-editable`, this.disableExternalIdEditable)
    this.$eventBus.$on(`form-modules-disable-description-editable`, this.disableDescriptionEditable)
  },
  beforeDestroy () {
    this.$eventBus.$off(`form-modules-dragstart`)
    this.$eventBus.$off(`form-modules-dragend`)
    this.$eventBus.$off(`form-modules-enable-name-editable`)
    this.$eventBus.$off(`form-modules-enable-externalid-editable`)
    this.$eventBus.$off(`form-modules-enable-description-editable`)
    this.$eventBus.$off(`form-modules-disable-name-editable`)
    this.$eventBus.$off(`form-modules-disable-externalid-editable`)
    this.$eventBus.$off(`form-modules-disable-description-editable`)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formmoduleform";
</style>
